import styled, { css } from 'styled-components';

import { colors } from 'theme/theme';

export const thumbnailPlayBackgroundVar = '--video-thumbnail-play-background';
export const thumbnailPlayColorVar = '--video-thumbnail-play-color';

const styles = css`
  position: relative;
  background: ${colors.lightContentGrey};
  user-select: none;

  ${thumbnailPlayBackgroundVar}: rgba(0, 0, 0, 0.3);
  ${thumbnailPlayColorVar}: ${colors.white};

  &:hover {
    ${thumbnailPlayBackgroundVar}: ${colors.white};
    ${thumbnailPlayColorVar}: ${colors.brandBlue};
  }

  > * {
    pointer-events: none;
  }
`;

export const VideoThumbnailHolder = styled.div`
  ${styles};
`;

export const VideoThumbnailButtonHolder = styled.button`
  ${styles};
  cursor: pointer;

  appearance: none;
  border: none;
  padding: 0;
  margin: 0;
`;
